const colors = {
  // 🧱 Backgrounds and surfaces
  background: "#121212", // Main screen background (alias for backgroundPrimary)
  backgroundPrimary: "#121212", // Main screen background
  backgroundSecondary: "#1A1A1A", // Lower part of the gradient / deep background
  surfaceCard: "#1E1E1E", // Cards, panels, UI components
  cardBackground: "#1E1E1E", // Cards, panels, UI components (alias for surfaceCard)
  surfaceBorder: "#2A2A2A", // Dividers and borders
  border: "#2A2A2A", // Dividers and borders (alias for surfaceBorder)

  // 🌈 Main background gradient (CSS)
  backgroundGradient: "linear-gradient(180deg, #121212 0%, #1A1A1A 100%)",
  // Or diagonal:
  // backgroundGradient: 'linear-gradient(135deg, #121212 0%, #202020 100%)',

  // ✨ Accent colors
  primary: "#3B82F6", // Primary buttons, active states (alias for accentPrimary)
  accentPrimary: "#3B82F6", // Primary buttons, active states
  secondary: "#22D3EE", // Secondary actions (alias for accentSecondary)
  accentSecondary: "#22D3EE", // Hover states, interactions
  accent: "#22D3EE", // Hover states, interactions (alias for accentSecondary)
  success: "#22C55E", // Gains, growth
  error: "#EF4444", // Losses, errors
  warning: "#F59E0B", // Warnings

  // 🖋️ Text and icons
  text: "#E5E7EB", // Main text content (alias for textPrimary)
  textPrimary: "#E5E7EB", // Main text content
  textSecondary: "#94A3B8", // Descriptions, secondary info
  textDisabled: "#6B7280", // Inactive or disabled items
  iconDefault: "#A1A1AA", // Default icons and graphic elements
  white: "#FFFFFF", // White text/icons

  // 🧪 UI overlays and extras
  divider: "#2A2A2A", // Section dividers
  hoverOverlay: "rgba(255,255,255,0.05)", // Hover feedback
  selectedOverlay: "rgba(59,130,246,0.1)", // Selected element background
};

export default colors; 